module.exports = __webpack_public_path__ + "img/Bääh.02da141c.svg";